<template>
  <v-dialog
    :value="show"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
    @input="val = $emit('update:show', val)"
  >
    <v-card>
      <v-card-title class="pb-0">
        <v-layout align-center>
          <v-layout
            class="headline"
            align-center
          >
            <v-icon
              class="mr-3"
              color="msr"
            >
              security
            </v-icon>
            {{ $t('changePassword') }}
          </v-layout>
          <v-btn
            class="ml-auto mr-0 my-0"
            flat
            icon
            :title="$t('cancel')"
            data-cy="change-password-dialog-abort-btn"
            @click="abort()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout column>
          <v-form
            ref="passwordForm"
            v-model="passwordFormIsValid"
            @submit.prevent
          >
            <v-text-field
              v-model="passwords.oldPassword"
              :label="$t('oldPassword')"
              :type="showPasswords ? 'text' : 'password'"
              :rules="[rules.oldPassword]"
              autofocus
              required
              @keyup.native.esc="abort()"
              @keyup.native.enter="confirm()"
            />
            <v-text-field
              v-model="passwords.newPassword1"
              :label="$t('newPassword')"
              :type="showPasswords ? 'text' : 'password'"
              :rules="[rules.newPassword]"
              required
              @keyup.native.esc="abort()"
              @keyup.native.enter="confirm()"
            />
            <v-text-field
              v-model="passwords.newPassword2"
              :label="$t('newPassword') + ' (' + $t('again') + ')'"
              :type="showPasswords ? 'text' : 'password'"
              :rules="[rules.newPassword]"
              required
              @keyup.native.esc="abort()"
              @keyup.native.enter="confirm()"
            />
          </v-form>
          <v-fade-transition>
            <v-alert
              v-if="newPasswordsExist && !newPasswordsAreEqual"
              value="true"
              error
              outline
            >
              {{ $t('passwordsMustBeEqual') }}
            </v-alert>
          </v-fade-transition>
          <v-layout align-center>
            <v-icon class="mr-3">
              {{ showPasswords ? 'visibility' : 'visibility_off' }}
            </v-icon>
            <v-switch
              v-model="showPasswords"
              color="msr"
              :label="$t('showPasswords')"
            />
          </v-layout>
          <v-layout row>
            <v-spacer />
            <v-btn
              class="mr-0"
              flat
              color="msr"
              @click="goToPasswordForgottenPage()"
            >
              {{ $t('forgotPassword') }}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <btn-ok
            :disabled="!passwordFormIsValid"
            data-cy="change-password-dialog-confirm-btn"
            round
            @click="confirm()"
          />
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnOk from '@/components/ButtonOk';

export default {
  components: {
    BtnOk,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      passwordFormIsValid: false,
      showPasswords: false,
      passwords: {
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
      },
      rules: {
        oldPassword: (value) => {
          return !!value || this.$t('passwordRequired');
        },
        newPassword: (value) => {
          const passwordHint = this.$t('passwordHint');
          if (!value) {
            return passwordHint;
          }
          let minSize = value.length >= 8;
          let noSpaces = value.indexOf(' ') === -1;
          let containsLetter = /[a-zA-Z]+/.test(value);
          let containsNumber = /[0-9]+/.test(value);
          return (
            (minSize && noSpaces && containsLetter && containsNumber) ||
            passwordHint
          );
        },
      },
    };
  },
  computed: {
    newPasswordsExist() {
      let new1Valid = this.passwords.newPassword1.trim() !== '';
      let new2Valid = this.passwords.newPassword2.trim() !== '';
      return new1Valid && new2Valid;
    },
    newPasswordsAreEqual() {
      return (
        this.passwords.newPassword1.trim() ===
        this.passwords.newPassword2.trim()
      );
    },
    canSubmitPasswordChange() {
      let oldExists = this.passwords.oldPassword.trim() !== '';
      let newExist = this.newPasswordsExist;
      let sameNew = this.newPasswordsAreEqual;
      let different =
        this.passwords.oldPassword.trim() !==
        this.passwords.newPassword1.trim();
      return (
        oldExists &&
        newExist &&
        sameNew &&
        different &&
        this.passwordFormIsValid
      );
    },
  },
  methods: {
    confirm() {
      if (!this.canSubmitPasswordChange) {
        return;
      }
      this.$emit('submitted');
    },
    abort() {
      this.$emit('aborted');
    },
    reset() {
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.reset();
      }
      this.passwords = {
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
      };
    },
    goToPasswordForgottenPage() {
      const confirmed = confirm(this.$t('confirmRequestNewPassword'));
      if (confirmed) {
        this.$api.logout().then(() => {
          this.$router.push('/passwordforgotten');
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ChangePasswordDialog.vue